// extracted by mini-css-extract-plugin
export var priceColumn = "line-item-module--priceColumn--e1f38";
export var remove = "line-item-module--remove--779dc";
export var title = "line-item-module--title--e4bda";
export var totals = "line-item-module--totals--69910";
export var variant = "line-item-module--variant--2bd54";